/**
 * Validation items are connect to individual controls or any other singular object that needs validation.
 */
export default class ValidationItem {
	id: string;
	label?: string;
	errorMessage: string | undefined;

	constructor(init: Partial<ValidationItem>) {
		if (!init?.id) {
			throw new Error('An id is required to initialize a ValidationItem');
		}
		Object.assign(this, init);
		this.id = init.id;
	}

	isValid() {
		return !this.errorMessage;
	}

	toString() {
		return this.label ?? this.id;
	}

	deleteValidation(id: string) {
		if (id === this.id) return true;
		return false;
	}
}
